<template>
  <v-card class="mx-auto ma-2" link :to="{ name: 'scene.site.details', params: { id: item._id } }">
    <SiteInformations :item="item" name="short_name" class="pt-3 pb-4"></SiteInformations>

    <v-divider></v-divider>

    <v-card-actions>
      <v-card-subtitle class="pa-0 ma-0">{{ drivingDistanceFormated }} {{ $t('km') }}</v-card-subtitle>

      <v-spacer></v-spacer>

      <v-btn icon small>
        <v-icon>mdi-chevron-right</v-icon>
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import moment from 'moment';
import { Config } from '@/config';
import SiteInformations from '@/components/SiteInformations';

export default {
  props: ['item'],
  data() {
    return {
      config: Config,
    };
  },
  components: {
    SiteInformations,
  },
  computed: {
    drivingDistanceFormated() {
      return (this.item.driving_distance / 1000).toFixed(1);
    },
    openingHours() {
      const isoDow = moment().isoWeekday();
      if (
        this.item.opening_hours !== undefined &&
        this.item.opening_hours[isoDow] !== undefined &&
        this.item.opening_hours[isoDow][0] !== undefined &&
        this.item.opening_hours[isoDow][1] !== undefined
      ) {
        return { start: this.item.opening_hours[isoDow][0], end: this.item.opening_hours[isoDow][1] };
      }
      return false;
    },
  },
  watch: {},
  mounted() {},
  created() {},
  methods: {},
};
</script>
